import { IConfigData } from '@df/catalog/config/config.interfaces';
import { NICmsContentField } from '@icms/core/content';
import { ICmsContentService } from '@icms/core/content/icms-content.service';
import { ICmsConfig } from '@icms/core/resource/config/icms-config';

export const CMS_CONFIG_ZENDESK = 'zendesk_config';

export interface IICmsConfigZendeskDataContent extends IConfigData {
    zendeskId?: string;
}
export interface IICmsConfigZendeskData extends ICmsConfig<IICmsConfigZendeskDataContent> {}

ICmsContentService.registerConfig({
    id: CMS_CONFIG_ZENDESK,
    name: 'Zendesk configuration',
    fields: [
        {
            key: 'zendeskId',
            type: NICmsContentField.EFieldType.text,
            title: 'ZenDesk id'
        }
    ]
});
